import { getAssetChanges, isAssetPath } from "./creativeSnapshotFields";
import { ChangeHistoryChange, ChangeHistoryRow } from "./types";
import { useCreativeSnapshot } from "./useCreativeSnapshot";

const ASSET_CHANGE_PATH = "/creative/assets";

/**
 * The asset rows of one history entry describe positions in the assets array, so they
 * are replaced by the fields that moved between the two snapshots. Without both
 * documents the rows are left alone and each one names itself as best it can.
 */
export const useAssetResolvedChanges = (
  row: ChangeHistoryRow
): ChangeHistoryChange[] => {
  const assetChanges = row.changes.filter((change) =>
    isAssetPath(change.fieldPath)
  );
  const first = assetChanges[0];

  const before = useCreativeSnapshot(first?.oldSnapshotId);
  const after = useCreativeSnapshot(first?.newSnapshotId);

  if (!first || !before || !after) return row.changes;

  const resolved = getAssetChanges(before, after).map((change, index) => ({
    id: `${first.id}-asset-${index}`,
    fieldPath: ASSET_CHANGE_PATH,
    entityType: first.entityType,
    entityId: first.entityId,
    ...change,
  }));

  return [
    ...row.changes.filter((change) => !isAssetPath(change.fieldPath)),
    ...resolved,
  ];
};
